type Urls = {
  apiUrl?: string;
  clmApiUrl?: string;
  accountApiUrl?: string;
};

/** Reference used to store urls */
export const urls = {
  apiUrl: '',
  clmApiUrl: '',
  accountApiUrl: '',
};

/**
 * Sets the urls object to be ready for services
 * - config: object - The environment config
 */
export const setUrls = (config: Partial<Urls>): void => {
  const { clmApiUrl, apiUrl, accountApiUrl } = config;

  Object.assign(urls, {
    apiUrl,
    clmApiUrl,
    accountApiUrl,
  });
};

export const getDocumentPathFromLanguage = (
  document: Record<string, string> | undefined,
  lang: string,
): string => {
  if (!document) {
    return '';
  }

  const path =
    document[lang.toLowerCase()] ?? document.default ?? document['en-us'];

  return path ?? '';
};

export const generateUserAgentHeader = ({
  appVersion,
  osType,
  osVersion,
}: {
  appVersion?: string;
  osType?: string;
  osVersion?: string;
}) => `clm;${appVersion ?? 'none'};${osType ?? 'none'};${osVersion ?? 'none'}`;
